import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  FormCheckbox,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from 'semantic-ui-react';

const MISMATCH_NPWP_DETAIL_AND_PHOTO = 'Mismatch NPWP detail and photo';
const NPWP_PHOTO_NOT_CLEAR = 'NPWP photo not clear';

function NpwpRejectConfirmationModal({ shown, onClose, onConfirm, isLoading }) {
  const [mismatchDetailAndPhoto, setMismatchDetailAndPhoto] = useState(false);
  const [photoNotClear, setPhotoNotClear] = useState(false);

  useEffect(() => {
    if (!shown) {
      setMismatchDetailAndPhoto(false);
      setPhotoNotClear(false);
    }
  }, [shown]);

  const onConfirmButtonClicked = () => {
    const reasons = [];
    if (mismatchDetailAndPhoto) {
      reasons.push(MISMATCH_NPWP_DETAIL_AND_PHOTO);
    }
    if (photoNotClear) {
      reasons.push(NPWP_PHOTO_NOT_CLEAR);
    }
    onConfirm(reasons.join(', '));
  };

  const onModalClosing = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal open={shown} onClose={onModalClosing}>
      <ModalHeader>Confirm Reject NPWP</ModalHeader>
      <ModalContent>
        <p>Rejection Reasons</p>
        <p>
          <em>Why do you reject merchant&#39;s data provided?</em>
        </p>
        <Form>
          <FormCheckbox
            label={MISMATCH_NPWP_DETAIL_AND_PHOTO}
            checked={mismatchDetailAndPhoto}
            onChange={() => setMismatchDetailAndPhoto(!mismatchDetailAndPhoto)}
            disabled={isLoading}
          />
          <FormCheckbox
            label={NPWP_PHOTO_NOT_CLEAR}
            checked={photoNotClear}
            onChange={() => setPhotoNotClear(!photoNotClear)}
            disabled={isLoading}
          />
        </Form>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          negative
          onClick={onConfirmButtonClicked}
          loading={isLoading}
          disabled={isLoading || (!mismatchDetailAndPhoto && !photoNotClear)}
        >
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
}

NpwpRejectConfirmationModal.propTypes = {
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default NpwpRejectConfirmationModal;
